import { render, staticRenderFns } from "./IFCModelViewer.vue?vue&type=template&id=85f87542"
var script = {}
import style0 from "./IFCModelViewer.vue?vue&type=style&index=0&id=85f87542&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports